import { SiteService } from './../site/service/site.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { LocalityService } from './service/locality.service';
import { Component, EventEmitter, OnInit } from '@angular/core';
import { LocalityInterface } from 'src/app/util/interfaces/locality';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';

@Component({
	selector: 'register-form-locality',
	templateUrl: './locality.component.html',
	styleUrls: ['./locality.component.scss'],
})
export class LocalityComponent implements OnInit {
	labels: any = {
		lbl_geral_localidade: 'Location',
		lbl_geral_site: 'Site',
		lbl_procurar_localidades: 'Search Locations',
		lbl_geral_selecione_localidade_editar: 'Select a location to edit',
		lbl_selecione_site: 'Select Site',
		lbl_geral_nova_localidade: 'New Location',
		lbl_geral_location_campos_redefinidos: 'All fields have been cleared',
		lbl_geral_location_ativar: 'Activate',
		lbl_geral_insira_nome_localidade: 'Enter some locality name',
		lbl_geral_desativar: 'Inactivate',
		lbl_geral_ativo: 'Active',
		lbl_status_desativado: 'Inactive',
		lbl_geral_pesquisar: 'Search',
		lbl_geral_sala: 'Room',
		lbl_geral_andar: 'Floor',
		lbl_geral_cidade: 'City',
		lbl_asset_inventario_endereco: 'Address',
		lbl_asset_inventario_estado: 'State',
		lbl_geral_observacoes: 'Notes',
		lbl_local_estoque: 'Local de Estoque',
		lbl_geral_salvar: 'Save',
		lbl_geral_location_limpar_campos: 'Reset the fields',
		lbl_geral_location_atualizada: 'Location has been updated',
		lbl_salvo_com_sucesso: 'Saved successfully',
		lbl_geral_location_preencha_campos: 'Fill in at least one note',
		lbl_geral_location_selecione_deletar: 'Select a location to delete',
		lbl_geral_location_selecione_ativar: 'Select a location to activate',
		lbl_geral_localidade_ativada: '',
		lbl_geral_localidade_existente: '',
		lbl_geral_localidade_desativada: '',
		lbl_geral_voltar: '',
	};

	searchHeader: mspTableHeaderI[] = [
		{ name: 'location', value: 'lbl_geral_localidades', colType: 'text' },
		{ name: 'active', value: 'lbl_geral_ativo', colType: 'boolean' },
	];

	constructor(
		private localityService: LocalityService,
		private siteService: SiteService,
		private notification: NotificationService,
		private LabelsService: LabelsService
	) {}

	isLoadingLabels = true;
	isUpdating = false;
	isChangingState = false;

	searchPaginationStart = 0;
	searchPaginationEnd = 0;

	isButtonVisible: string | number;
	locality = {} as LocalityInterface;
	customInterface: LocalityInterface = {
		id: undefined,
		location: '',
		site: '',
		room: '',
		floor: '',
		city: '',
		address: '',
		state: '',
		info: '',
		active: '',
		is_stock: false,
		name_site: '',
	};

	setValue: any = '';
	setInputText: any = '';

	// Localidades
	locationsList: LocalityInterface[] = [];
	listLocationsIAC: iacOptionInterface[] = [];
	isLoadingLocations = true;
	clearValuesLocation = false;
	placeholderLocation = '';

	// Sites
	siteList: LocalityInterface[] = [];
	listSitesIAC: iacOptionInterface[] = [];
	isLoadingSites = true;
	clearValuesSite = false;
	placeholderSite = '';
	unselectValue = true;

	ngOnInit() {
		this.setInputText = '';
		this.LabelsService.getLabels().subscribe((labels) => {
			this.getAllLocations();
			this.getAllSites();
			this.labels = labels;
			this.isLoadingLabels = false;
		});
	}

	// Todos as localidades na lista
	getAllLocations() {
		this.localityService.getAllLocations().subscribe((locations) => {
			this.listLocationsIAC = [];
			this.locationsList = [];
			this.locationsList = locations;
			for (const item of this.locationsList) {
				const newIacOptionLocation: iacOptionInterface = {
					name: item.name_site + ', ' + item.location,
					value: item.id,
					commonGroup: item.active === 1 ? this.labels.lbl_geral_ativo : this.labels.lbl_status_desativado,
				};
				this.listLocationsIAC.push(newIacOptionLocation);
			}
			this.sort(true);
			this.isLoadingLocations = false;
		});
	}

	// Coleta o a localidade para form
	getLocation(idLocation: string) {
		this.localityService.getLocalityByID(idLocation).subscribe((resp) => {
			this.customInterface = resp;
			this.isButtonVisible = this.customInterface.active;
		});
	}

	// Todos os sites na lista
	getAllSites() {
		this.siteService.getAllSites().subscribe((sites) => {
			this.siteList = sites;
			for (const item of this.siteList) {
				const newIacOption: iacOptionInterface = {
					name: item.site,
					value: item.id,
					commonGroup: item.active === 1 ? this.labels.lbl_geral_ativo : this.labels.lbl_status_desativado,
				};
				this.listSitesIAC.push(newIacOption);
			}
			this.isLoadingSites = false;
		});
	}

	//Coleta o número/id do site através do "getAllSites()"
	getSite(idSite: string) {
		this.customInterface.site = idSite;
	}

	//Limpar Campos
	clearInputs(newLocality: boolean) {
		this.clearValuesLocation = true;
		setTimeout(() => {
			this.clearValuesLocation = false;
		}, 1);

		this.clearValuesSite = true;
		setTimeout(() => {
			this.clearValuesSite = false;
		}, 1);

		// Remove o botão de desativação/ativação do form
		this.isButtonVisible = '';

		// Limpa os campos
		this.customInterface = {
			id: newLocality ? '' : undefined,
			location: '',
			site: '',
			room: '',
			floor: '',
			city: '',
			address: '',
			state: '',
			info: '',
			active: '',
			is_stock: false,
			name_site: '',
		};

		this.locality = {
			id: newLocality ? '' : undefined,
			location: '',
			site: '',
			room: '',
			floor: '',
			city: '',
			address: '',
			state: '',
			info: '',
			active: '',
			is_stock: false,
			name_site: '',
		};
	}

	//Validar os 2 campos com * se estão vazios
	validateForm() {
		if (this.customInterface.site === '') {
			this.notification.setNotificationMessage(this.labels.lbl_selecione_site);
			return false;
		}

		if (this.customInterface.location === '') {
			this.notification.setNotificationMessage(this.labels.lbl_geral_insira_nome_localidade);
			return false;
		}

		this.saveLocality();
	}

	//Salvar localidade
	saveLocality() {
		if (this.isUpdating || this.isChangingState) return;
		this.isUpdating = true;

		if (this.customInterface.id === '') {
			this.localityService.postLocality(this.customInterface).subscribe((data) => {
				if (data[0].status === 'error') {
					return this.notification.setNotificationMessage(this.labels.lbl_geral_localidade_existente);
				} else {
					this.notification.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
					this.isLoadingLocations = true;
					this.getAllLocations();
					this.isLoadingLocations = true;
				}
				this.isUpdating = false;
			});
		}

		if (this.customInterface.id || this.customInterface.id != '') {
			this.localityService.updateLocality(this.customInterface).subscribe((data) => {
				if (data[0].status === 'error') {
					return this.notification.setNotificationMessage('_Já possui uma localidade com este site');
				}

				this.notification.setNotificationMessage(this.labels.lbl_geral_location_atualizada);
				this.isLoadingLocations = true;
				this.getAllLocations();
				this.getLocation(this.customInterface.id);
				this.isLoadingLocations = true;
				this.isUpdating = false;
			});
		}
	}

	//Desativa uma localidade
	deleteLocality(id: string) {
		if (this.isUpdating || this.isChangingState) return;
		this.isChangingState = true;

		if (this.customInterface.id || this.customInterface.id != '')
			this.localityService.deleteLocality(this.customInterface).subscribe((data) => {
				this.getAllLocations();
				this.isButtonVisible = 0;
				this.notification.setNotificationMessage(this.labels.lbl_geral_localidade_desativada);
				this.isChangingState = false;
			});
	}

	//Ativar Localidade
	activeLocality(id: string) {
		if (this.isUpdating || this.isChangingState) return;
		this.isChangingState = true;

		this.localityService.activeLocality(this.customInterface).subscribe((data) => {
			this.getAllLocations();
			this.isButtonVisible = 1;
			this.notification.setNotificationMessage(this.labels.lbl_geral_localidade_ativada);
			this.isChangingState = false;
		});
	}

	sort(sortDown: boolean): void {
		this.locationsList.sort((a, b) => {
			if (a.location > b.location) return sortDown ? 1 : -1;
			if (b.location > a.location) return sortDown ? -1 : 1;
			return 0;
		});
	}
}
